import { User } from 'oidc-client-ts';

import { config } from '@/config';
import { userStorageKey } from '@/features/auth/oidcSettings';

/**
 * The signed-in user as oidc-client-ts persisted it, read straight from
 * sessionStorage. This exists for code that runs outside the React tree — the
 * Chunk 2 API client attaches the bearer token per request without needing a
 * hook. Components should keep using `useAuth()` so they re-render on change.
 *
 * Unaffected by `accounts.ts`: under the WP-04 fallback only one account has
 * a live session at a time, so "the active account's token" and "the
 * sessionStorage user" are the same thing — `AccountStore.activeSub` tracks
 * *which* account that is for the UI, it doesn't add a second token source.
 */
export function getStoredUser(): User | null {
  const raw = sessionStorage.getItem(userStorageKey(config));
  if (!raw) return null;
  return User.fromStorageString(raw);
}

/** The current access token, or null when signed out or expired. */
export function getAccessToken(): string | null {
  const user = getStoredUser();
  if (!user || user.expired) return null;
  return user.access_token;
}
